import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';

export interface IPieChartDataItem {
    value: number;
    name: string;
    color?: string;
}
interface IPieChart {
    data: IPieChartDataItem[];
    total: string;
    totalText: string;
    name: string;
    title?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
}

export const PieChart = ({
    name,
    title,
    width,
    height,
    data,
    total,
    totalText,
    className,
}: IPieChart) => {
    const option: EChartsOption = {
        tooltip: {
            trigger: 'item',
        },
        legend: {
            align: 'left',
            left: '60%',
            icon: 'circle',
            orient: 'vertical',
            top: 'middle',
        },
        series: [
            {
                name,
                type: 'pie',
                center: ['30%', '50%'],
                radius: ['100%', '75%'],
                avoidLabelOverlap: false,
                label: {
                    show: true,
                    position: 'center',
                    formatter: () => {
                        const safeTotal =
                            total !== undefined && total !== null ? total : '';
                        const safeTotalText =
                            totalText !== undefined && totalText !== null
                                ? totalText
                                : '';
                        return `{a|${safeTotal}}\n{b|${safeTotalText}}`;
                    },
                    rich: {
                        a: {
                            fontSize: 20,
                            color: '#333',
                            lineHeight: 25,
                        },
                        b: {
                            fontSize: 12,
                            color: '#999',
                            lineHeight: 20,
                        },
                    },
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 16,
                        fontWeight: 'bold',
                    },
                    itemStyle: {
                        opacity: 0.95,
                    },
                    scale: false,
                    focus: 'none',
                },
                labelLine: {
                    show: false,
                },
                data: data.map((item) => ({
                    value: item.value,
                    name: item.name,
                    ...(item.color ? { itemStyle: { color: item.color } } : {}),
                })),
            },
        ],
    };

    return (
        <>
            {title && (
                <h3 className="text-lg font-bold text-navyBlue">{title}</h3>
            )}
            <ReactECharts
                option={option}
                style={{ height, width }}
                className={className}
            />
        </>
    );
};
